import { w as writable } from "./index2.js";
const allUnits = writable([]);
export {
  allUnits as a
};
//# sourceMappingURL=unit.js.map
